export const getFormBuilderUrl = () => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost:3004'
    }
    
    switch (process.env.REACT_APP_ENV) {
        case 'staging':
            return 'https://enterprise-workflow-form-builder-stg.instinct.pltsci.com'
        default:
            return 'https://enterprise-workflow-form-builder-stg.instinct.pltsci.com'
    }
}
